"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientRefreshTokens = (force: boolean) => {
  const queryParam = force ? "?force=true" : ""
  return fetchInterceptorInClient(
    {
      method: "post",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/account/authenticate/tokens/refresh${queryParam}`).then(
    resultPostprocessing2,
  )
}

export default fetchClientRefreshTokens
